import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

export const getPayrollConditionList = createAsyncThunk(
  'PayrollConditions/getPayrollConditionList',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.get(`Payroll/GetHrPayrollConditionList?PayrollId=${id}`);
      return data.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addPayrollConditions = createAsyncThunk(
  'PayrollConditions/addPayrollConditions',
  async (item: any, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post<APIResponse<any>>('Payroll/AddPayrollConditions', item);
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deletePayrollCondition = createAsyncThunk(
  'PayrollConditions/deletePayrollCondition',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `Payroll/DeletePayrollCondition?Id=${id}`
      );
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  PayrollConditionList: PayrollConditionInterface[];
  loading: boolean;
  error: any | null;
} = {
  PayrollConditionList: [],
  loading: false,
  error: null
};

const PayrollConditionsSlice = createSlice({
  name: 'PayrollConditions',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      ///////   get Payroll ConditionList
      .addCase(getPayrollConditionList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPayrollConditionList.fulfilled, (state, action) => {
        state.loading = false;
        state.PayrollConditionList = action.payload;
      })
      .addCase(getPayrollConditionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default PayrollConditionsSlice.reducer;

interface PayrollConditionInterface {
  id: string;
  name: string;
  name2: string;
  payrollId: string;
  payrollName: string;
  payrollName2: string;
  code: string;
  parameterOne: string;
  description: string;
  staticType: string;
}
